import React, { useState } from 'react'
import { Card } from 'react-bootstrap';
// import WeatherDropdown from '../Components/WeatherDropdown'

const WeatherDetails = () => {
  const [ location, setLocation ] = useState('')
  const [ weatherData, setWeatherData ] = useState({})

  const handleLocationClick = async () => {
    setLocation(location);
    const API_KEY = 'd794c1d104981f7443e3432adacd14a8'

    try {
      const res = await fetch(
        `https://api.openweathermap.org/data/2.5/weather?q=${location}&appid=${API_KEY}&units=metric`
      );
      const data = await res.json();
      setWeatherData(data);
    } catch (err) {
      console.error('Weather fetch failed', err);
    }
  }

  return (
    <Card className='card-background'>
      <div className='location-input'>
        <input
          id='input'
          className='location-text-field'
          placeholder='type your location here'
          onBlur={ event => setLocation(event.target.value)}
          >
        </input>
      </div>
      <div className='location-input'>
        <button
          id='button'
          className='location-text-field'
          onClick={() => handleLocationClick()}
        >
          Search
        </button>
      </div>
      {weatherData?.base && 
        <div className='location-input'>
          <ul className="weather-info-text">
            <li>Temperature: {weatherData?.main?.feels_like}</li>
            <li>Humidity: {weatherData?.main?.humidity}</li>
            <li>Weather: {weatherData?.weather[0]?.main}</li>
            <li>Description: {weatherData?.weather[0]?.description}</li>
          </ul>
        </div>
      }
    </Card>
  )
}

export default WeatherDetails